<script setup lang="ts">
import type { Program } from '../types/general';

const props = defineProps<{
  card: Program;
}>();
</script>

<template>
  <div class="explore-card">
    <div class="explore-card__title">
      <h3>{{ props.card.title }}</h3>
      <span
        v-if="props.card.apply_now"
        class="explore-card__title__tag"
      >
        <a :href="props.card.apply_now" :target="props.card.apply_now_target">Apply Now</a>
      </span>
    </div>
    <div class="explore-card__content">
      <div>
        <p class="explore-card__content__title">Who it’s for</p>
        <p>{{ props.card.who_its_for }}</p>
      </div>
      <div v-if="props.card.duration">
        <p class="explore-card__content__title">Duration</p>
        <p>{{ props.card.duration.text }}</p>
      </div>
    </div>
    <div class="explore-card__cta">
      <a
        class="btn btn-sm"
        :href="props.card.learn_more"
        >Learn More</a
      >
      <a
        v-if="props.card.show_subprograms_link && props.card.subprograms_link"
        class="explore-card__cta__more"
        :target="props.card.subprograms_link.is_external ? '_blank' : '_self'"
        :href="props.card.subprograms_link.uri"
        >{{ props.card.subprograms_link.title }}</a
      >
    </div>
  </div>
</template>
